import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"

const CategoryDelete = ({ id, name, onDelete, onCancel }) => (
  <BlankSlate
    icons={null}
    heading={`Are you sure you want to delete the category, ${name}?`}
    body="Deleting this category will not impact any resources previously included under it."
    primaryAction={{
      children: "Yes, Delete",
      dangerous: true,
      onClick: () => onDelete(id)
    }}
    secondaryAction={{
      children: "Cancel",
      onClick: () => onCancel(id)
    }}
  />
)

CategoryDelete.displayName = "CategoryDelete"

export default CategoryDelete
